import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { RegulationContext, SidebarContext } from "../../../App";
import { LS_AUTHORITY_KEY, LS_UI_ELEMENTS_CONFIG_KEY, USER_ROLE } from '../../../core/constants/common';
import { SidebarMenu } from "../../../core/constants/sidebarMenu";
import PermissionUtils from "../../../core/utilities/PermissisonUtils";
import { hasGoalsKpiNavAccess } from "../../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions";
import ESGAILogo from "../../../images/ESG-AI.png";
import Ecodrisil_logoExpress from "../../../images/Ecodrisil_express_esg_logo.webp";
import Ecodrisil_logoExpressDrak from "../../../images/Ecodrisil_express_esg_logo_Dark.webp";
import img_GriContent from "../../../images/GRI-LicensingMarks-ContentPermission2026-mark.png";
import img_GriSoftware from "../../../images/GRI-LicensingMarks-Partner2026-v1.png";
import Slim_view_logo from "../../../images/Slim_logo_light.webp";
import "./Sidebar.scss";
import SidebarItem from "./SidebarItem";

const Sidebar = ({ t }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const data = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const code = glbRegulation?.code;
  const { sidebarDisplay } = useContext(SidebarContext);
  const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY)) ?? null;
  // TEMPORARY: same Goals & KPI nav check used to hide the rest of the app chrome. Revisit soon.
  const restrictNavToGoalsKpi = hasGoalsKpiNavAccess(
    buildHierarchyPermissions(Array.isArray(data?.roles) ? data.roles : [])
  );

  const menuItems = data?.roles?.includes("SUPER_ADMIN")
    ? SidebarMenu({ t }, code, "SUPER_ADMIN")
    : SidebarMenu({ t }, code);
  
  /********************these are the old permissions before Inroducing keyclock***************************** */
  //  if (data.roles.includes(USER_ROLE.SUPPLIER_ADMIN)
  //   || data.roles.includes(USER_ROLE.SUPPLIER_RISK_ASSESSOR)
  //   || data.roles.includes(USER_ROLE.SUPPLIER_TEAM_MEMBER)) {
  //   menuItems = SidebarMenu({ t }, code, "SUPPLIER_ADMIN");
  // }

  useEffect(() => {
    // Function to check if the screen width is less than 780px
    const handleResize = () => {
      setIsSmallScreen(window.matchMedia('(max-width: 780px)').matches);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Check initial screen size
    handleResize();

    // Remove event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`Sidebar ${sidebarDisplay ? '' : 'sidebar_slim'} ${isSmallScreen ? 'sidebar_slim' : ''}`}>
      <ul className="Sidebar_list 1" role="menubar" aria-label="Main navigation">
        {menuItems?.map((item, index) => (
          <SidebarItem key={index} item={item} />
        ))}
      </ul>
      {/* TEMPORARY: hide GRI licensing marks when Goals & KPI nav access is present. Revisit soon. */}
      {!restrictNavToGoalsKpi && (
        <div className="GRI-Org02">
          <div className="Org_img">
            <img src={img_GriSoftware} data-tip="SOFTWARE AND TOOLS PARTNER" />
          </div>
          <div className="Org_img">
            <img src={img_GriContent} data-tip="CONTENT USED WITH PERMISSION" />
          </div>
        </div>
      )}
      <div className="CL_01Es">
        {
          uiElementsConfig?.texts?.partnerLogoURL
            ?
            <img className="light_logo" src={uiElementsConfig?.texts?.partnerLogoURL} />
            :
            <>
              {
                data?.profile?.company?.legalName !== "Roads & Transport Authority" &&
                <img className="light_logo" src={Ecodrisil_logoExpress} />
              }
              {
                data?.profile?.company?.legalName === "Roads & Transport Authority" &&
                <img className="light_logo" src={ESGAILogo} />
              }
              <img className="Drak_logo" src={Ecodrisil_logoExpressDrak} />
              <img className="Slim_logo" src={Slim_view_logo} />
            </>
        }
      </div>

    </div >
  );
};

export default withTranslation()(Sidebar);
